import {Component, Input} from '@angular/core';
import {Aangifte, IncomeTaxEntity} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-voorheffingen',
  templateUrl: './voorheffingen.component.html',
  styleUrls: ['./voorheffingen.component.scss'],
})
export class VoorheffingenComponent {

    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    private currentAangifte = {} as Aangifte;
    private partnerAangifte = {} as Aangifte;

}
